import Checkbox from "@mui/material/Checkbox";
import { maskHourAndMinutes } from "~/utils/date";

// Componentes no nível do módulo: nunca remontam a cada render do painel (conserto de E7/T21).

// O DataGrid captura teclas (espaço seleciona a linha, setas navegam): inputs dentro da célula param a propagação.
const stopGridKeys = (onEnter) => (event) => {
  event.stopPropagation();
  if (event.key === "Enter") onEnter();
};

export function PaymentDateCell({ rowId, value, draft, disabled, onDraft, onCommit }) {
  const shown = draft !== undefined ? draft : (value || "").slice(0, 10);
  const commit = () => onCommit(rowId, "normal_payment_date");
  return (
    <input
      type="date"
      aria-label={`Data de pagamento normal ${rowId}`}
      value={shown}
      disabled={disabled}
      onChange={(e) => onDraft(rowId, "normal_payment_date", e.target.value)}
      onBlur={commit}
      onKeyDown={stopGridKeys(commit)}
      style={{ width: "100%" }}
    />
  );
}

function HourInput({ rowId, field, label, value, draft, disabled, onDraft, onCommit }) {
  const commit = () => onCommit(rowId, field);
  return (
    <input
      aria-label={`${label} ${rowId}`}
      value={draft !== undefined ? draft : value || ""}
      maxLength={5}
      disabled={disabled}
      onChange={(e) => onDraft(rowId, field, maskHourAndMinutes(e.target.value))}
      onBlur={commit}
      onKeyDown={stopGridKeys(commit)}
      style={{ width: 52 }}
    />
  );
}

export function RealizedCell({ row, drafts, disabled, onDraft, onCommit }) {
  return (
    <span style={{ display: "inline-flex", gap: 4, alignItems: "center" }}>
      <HourInput
        rowId={row.id}
        field="real_start_hour"
        label="Início realizado"
        value={row.real_start_hour}
        draft={drafts[`${row.id}.real_start_hour`]}
        disabled={disabled}
        onDraft={onDraft}
        onCommit={onCommit}
      />
      –
      <HourInput
        rowId={row.id}
        field="real_end_hour"
        label="Saída realizada"
        value={row.real_end_hour}
        draft={drafts[`${row.id}.real_end_hour`]}
        disabled={disabled}
        onDraft={onDraft}
        onCommit={onCommit}
      />
    </span>
  );
}

export function FlagCell({ rowId, field, label, value, disabled, onToggle }) {
  return (
    <Checkbox
      checked={Boolean(value)}
      disabled={disabled}
      onChange={(e) => onToggle(rowId, field, e.target.checked)}
      onKeyDown={(e) => e.stopPropagation()}
      inputProps={{ "aria-label": `${label} ${rowId}` }}
    />
  );
}

export const PAYMENT_RULES = [
  { value: "proportional", label: "Proporcional com limite" },
  { value: "total", label: "Integral" },
  { value: "proportional-overtime", label: "Proporcional sem limite de tempo" },
];

export function PaymentRuleCell({ rowId, value, disabled, onChange }) {
  return (
    <select
      aria-label={`Regra de pagamento ${rowId}`}
      value={value || "proportional"}
      disabled={disabled}
      onChange={(e) => onChange(rowId, e.target.value)}
      onKeyDown={(e) => e.stopPropagation()}
    >
      {PAYMENT_RULES.map((rule) => (
        <option key={rule.value} value={rule.value}>
          {rule.label}
        </option>
      ))}
    </select>
  );
}
